import React from 'react'
import PropTypes from 'prop-types'

const OrderValue = ({ orderType }) => (
  <div
    style={{
      color: '#6d6e71',
      fontSize: '14px',
      backgroundColor: 'rgba(0, 113, 206, 0.05)',
      borderRadius: '13px',
    }}
    data-testid="order-value-testid"
  >
    <div style={{ padding: '2px 8px' }}>
      Ordenar por
      <span style={{ color: '#0071ce', fontWeight: 'bold' }}>{` ${orderType}`}</span>
    </div>
  </div>
)

OrderValue.propTypes = {
  orderType: PropTypes.string.isRequired,
}

export default OrderValue
